// Add your custom JS here.

(function($) {

  //to-top
  $(function() {
      let showFlag = false;
      const topBtn = $('.to-top');    
      topBtn.css('bottom', '-100px');
      //スクロールが100に達したらボタン表示
      $(window).on('scroll', function () {
          if ($(this).scrollTop() > 100) {
              if (showFlag == false) {
                  showFlag = true;
                  topBtn.stop().animate({'bottom' : '0'}, 200); 
              }
          } else {
              if (showFlag) {
                  showFlag = false;
                  topBtn.stop().animate({'bottom' : '-100px'}, 200); 
              }
          }
      });

      topBtn.on('click', function(){
        $('body,html').animate({
          scrollTop: 0},500);
          return false;
      });

  });



  // スムーススクロール
  // headerの高さを取得し、headeHeightに代入
  //const headerHeight = document.getElementById('main-nav').offsetHeight;
  const headerHeight = 16;
  
  //querySelectorAllメソッドを使用してページ内のhref属性が#で始まるものを選択
  //forEachメソッドを使って、各アンカータグにクリックされた時の処理
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
  
      // クリックされたときのデフォルトの挙動を防ぐ
      e.preventDefault();
  
      // クリックされたアンカータグのhref属性を取得
      const href = anchor.getAttribute('href');
  
      // href属性の#を取り除いた部分と一致するIDを取得
      const target = document.getElementById(href.replace('#', ''));
  
      if(target !== null){
        //取得した要素の位置を取得するために、getBoundingClientRect()を呼び出し、ページ上の位置を計算。
        //headerの高さを引いて、スクロール位置がヘッダーの下になるように調整します。
        const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;
  
        // window.scrollTo()を呼び出して、スクロール位置を設定します。behaviorオプションをsmoothに設定することで、スムーズなスクロールを実現します。
        window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
        });
      }
    });
  });
  
  // スムーススクロール ページ外
  document.addEventListener("DOMContentLoaded", () => {
    if (location.hash) {
      //const headerHeight = document.getElementById("main-nav").clientHeight;
      const headerHeight = 100;
      setTimeout(() => {
        window.scrollBy(0, - headerHeight);
      },100)
    }
  })






})(jQuery);